module.exports = __webpack_public_path__ + "img/rvdsb-5@2x.fac1a552.png";